export const BANNER_COOKIE = Object.freeze({
  READ_ONLY_ROLE_BANNER_CLOSED: "read-only-role-banner-closed",
});

export default {};
